/* eslint-disable react-hooks/exhaustive-deps */
import Divider from "@mui/material/Divider";
import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { getAuthTokenCookie, removeAdminAuthTokenCookie, removeAuthTokenCookie, resetEverything } from "../../utils/cookieUtils";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FiChevronDown } from "react-icons/fi";
import { setBuySellActiveTab, setProfile, setProjectsActiveTab, setAdminDashboardTab } from "../../state/reducers/applicationSlice";
import ProfileImageUpload from "../ProfileImageUpload";
import authService from "../../services/authService";
import { setUserData, setVendorData } from "../../state/reducers/userSlice";
import propertyService from "../../services/propertyService";
import { fileToBase64 } from "../../utils/fileUtils";
import vendorKycService from "../../services/vendorKycService";
import { HiOutlineArrowLeft } from "react-icons/hi2";
import { LuLayoutDashboard } from "react-icons/lu";
const Header = () => {
  const dispatch = useDispatch();
  const storeUserData = useSelector((state) => state?.user?.userData);
  const profile = useSelector((state) => state?.application?.profile);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuVisible, setMenuVisible] = useState(false);
  const userData = useSelector((state) => state.user);
  const kycStatus = storeUserData?.loggedIn === "Customer" ? JSON.parse(localStorage.getItem("userData"))?.isKycDone : true;
  const BUY_SELL_PATHS = ["/buy-sell", "/add-existing-project", "/edit-existing-project"];
  const PROJECTS_PATHS = ["/projects", "/add-new-project", "/edit-new-project"];
  const FAQ_PATHS = ["/faq"];
  const DIRECTORY_PATHS = ["/directory"];

  const MY_BIDS_PATH = ["/my-bids"];
  const baseClass = `text-sm 3xl:text-lg text-white rounded-full py-2 p-4 ${
    pathname === "/" ? "cursor-pointer group-hover:text-primary" : "hover:bg-white hover:text-primary"
  }`;
  const activeClass = `text-sm 3xl:text-lg ${pathname === "/" ? "text-white bg-primary" : "text-primary bg-white"} rounded-full py-2 p-4`;

  const baseMobileClass = `block text-sm rounded-lg py-2.5 px-1 font-medium text-gray-400 ${
    pathname === "/" ? "cursor-pointer group-hover:text-primary" : "hover:bg-white hover:text-primary"
  }`;
  const activeMobileClass = `block text-sm font-medium ${pathname === "/" ? "text-white bg-primary" : "bg-primary text-white"} rounded-lg py-2.5 p-4`;

  const baseClassAdmin =
    "group rounded-md flex items-center my-3 py-2 px-4 font-semibold text-sm text-primary hover:bg-primary hover:text-white cursor-pointer";
  const activeClassAdmin = "group rounded-md flex items-center my-3 py-2 px-4 font-semibold text-sm bg-primary text-white cursor-pointer";

  const baseClassAdmin1 =
    "group rounded-md flex items-center my-3 py-2 px-4 font-semibold text-sm text-white hover:bg-white hover:text-primary cursor-pointer";
  const activeClassAdmin1 =
    "group rounded-md flex items-center my-3 py-2 px-4 font-semibold text-sm bg-white border border-primary text-primary cursor-pointer";
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onClickVendorKyc = () => {
    navigate("/vendor-kyc");
    setAnchorEl(null);
  };
  const onClickProfile = () => {
    if (profile) {
      navigate("/consumer-profile");
    } else {
      navigate("/vendor-profile");
    }
  };
  const onClickSwitch = () => {
    toast.success(`Switched to ${!profile ? "Consumer" : "Vendor"} profile.`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      theme: "light",
    });
    let value = localStorage.getItem("profile") === "true";
    dispatch(setProfile(!profile));
    dispatch(setBuySellActiveTab(0));
    dispatch(setProjectsActiveTab(0));
    localStorage.setItem("profile", !value);
    setAnchorEl(null);
    navigate("/buy-sell");
  };
  const handleToggleMenu = () => {
    setMenuVisible(!menuVisible);
  };
  const handleCloseMenu = () => {
    setMenuVisible(false);
  };
  const handleNavigateLanding = () => {
    navigate("/");
  };
  const handleNavigateLogin = () => {
    // navigate("/login");
    window.open(`${process.env.REACT_APP_SSO_URL}login`, "_self");
  };
  const handleNavigateSignup = () => {
    // navigate(handleNavigateSignup());
    resetEverything();
    window.open(`${process.env.REACT_APP_SSO_URL}signup`, "_self");
  };
  const handleNavigatePlatforms = () => {
    // navigate(handleNavigateSignup());
    window.open(`${process.env.REACT_APP_SSO_URL}platforms`, "_self");
  };
  const handleLogout = () => {
    toast.success(`You have been successfully logged out.`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      theme: "light",
    });
    if (storeUserData?.loggedIn === "Customer") {
      // navigate("/login");
      window.open(`${process.env.REACT_APP_SSO_URL}login`, "_self");
    } else {
      navigate("/admin/login");
    }
    removeAdminAuthTokenCookie();
    removeAuthTokenCookie();
  };
  const getConsumerDetails = async () => {
    try {
      let response = await authService.getConsumerDetails();
      if (response.data.status) {
        downloadProfileImage(response?.data?.data?.profile_photo);
      }
    } catch (error) {
      console.log("Consumer details fetch Error", error);
    }
  };
  const getVendorKycDetails = async () => {
    try {
      let response = await vendorKycService.getVendorKycDetails();
      if (response?.data?.status) {
        downloadProfileImage(response?.data?.data?.profile_photo);
        dispatch(setVendorData({ ...response?.data?.data }));
        localStorage.setItem("vendorData", JSON.stringify({ ...response?.data?.data }));
      }
    } catch (error) {
      console.log("Error fetching vendor details.", error);
    }
  };
  const downloadProfileImage = async (url) => {
    if (url) {
      try {
        const image = await propertyService.downloadPropertyMedia(url);
        const blob = new Blob([image.data], { type: "image/jpeg" });
        const file = new File([blob], "image.jpg", { type: "image/jpeg" });
        try {
          const base64String = await fileToBase64(file);
          let userData = null;
          if (profile) {
            userData = {
              ...storeUserData,
              profilePhotoUrl: url,
              profilePhoto: base64String,
            };
          } else {
            userData = {
              ...storeUserData,
              vendorProfilePhotoUrl: url,
              vendorProfilePhoto: base64String,
            };
          }

          localStorage.setItem("userData", JSON.stringify(userData));
          dispatch(setUserData(userData));
        } catch (error) {
          console.error("Error converting file to base64", error);
        }
      } catch (error) {
        console.log("Error downloading profile image");
      }
    } else {
      let userData = null;
      if (profile) {
        userData = {
          ...storeUserData,
          profilePhotoUrl: null,
          profilePhoto: null,
        };
      } else {
        userData = {
          ...storeUserData,
          vendorProfilePhotoUrl: null,
          vendorProfilePhoto: null,
        };
      }
      localStorage.setItem("userData", JSON.stringify(userData));
      dispatch(setUserData(userData));
    }
  };
  useEffect(() => {
    if (pathname !== "/" && !kycStatus) {
      navigate("/not-found");
    } else {
      // getVendorKycStatus();
    }
  }, []);
  useEffect(() => {
    if (getAuthTokenCookie()) {
      if (storeUserData?.loggedIn === "Customer") {
        if (profile) {
          getConsumerDetails();
        } else {
          getVendorKycDetails();
        }
      }
    }
  }, [profile]);
  const dashboardTab = useSelector((state) => state?.application?.adminDashboardTab);
  return (
    <div>
      <header
        style={{ transition: "0.25s" }}
        className={` w-full xs:z-[500] lg:z-50 px-4 ${
          (storeUserData?.loggedIn === "Customer" || !storeUserData?.loggedIn) && "xl:px-24 2xl:px-48"
        }  absolute ${pathname === "/" ? "hover:bg-white group" : "bg-primary relative"}`}
      >
        <nav className="relative py-4 3xl:py-5 flex justify-between items-center">
          <span className="text-3xl font-bold leading-none">
            <img
              className={storeUserData?.loggedIn === "Customer" ? "cursor-pointer" : "cursor-default126"}
              src={require("../../assets/images/gaed-logo.png")}
              alt="logo"
              onClick={() => {
                if (storeUserData?.loggedIn === "Customer") {
                  handleNavigateLanding();
                }
              }}
            />
          </span>
          <div className="lg:hidden">
            <button className="navbar-burger flex items-center text-white p-3 group-hover:text-primary" onClick={handleToggleMenu}>
              <svg className="block h-6 w-6 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <title>Mobile menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
              </svg>
            </button>
          </div>
          {/* -translate-x-1/4left-48 */}
          <ul className="hidden absolute top-1/2 left-20 transform -translate-y-1/2  lg:flex lg:mx-auto lg:items-center lg:w-auto lg:space-x-6">
            {storeUserData?.loggedIn === "Customer" ? (
              <>
                {/* <li>
                  <NavLink className={`${HOME_PATHS.includes(pathname) ? activeClass : baseClass}`} to="/">
                    Home
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    className={`${DIRECTORY_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                    onClick={() => {
                      getAuthTokenCookie() ? handleNavigatePlatforms() : handleNavigateSignup();
                    }}
                  >
                    Platforms
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={`${BUY_SELL_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                    to={getAuthTokenCookie() ? "/buy-sell" : handleNavigateSignup()}
                  >
                    Buy/Sell
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={`${PROJECTS_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                    to={getAuthTokenCookie() ? "/projects" : handleNavigateSignup()}
                  >
                    Projects
                  </NavLink>
                </li>
                {!profile && (
                  <li>
                    <NavLink
                      className={`${MY_BIDS_PATH.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                      to={getAuthTokenCookie() ? "/my-bids" : handleNavigateSignup()}
                    >
                      My Bids
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    className={`${FAQ_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                    to={"/faq"}
                  >
                    FAQ
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    className={`${DIRECTORY_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                    to={getAuthTokenCookie() ? "/directory" : handleNavigateSignup()}
                  >
                    Directory
                  </NavLink>
                </li> */}
              </>
            ) : (
              <>
                {storeUserData ? (
                  <>
                    <li>
                      <NavLink className={pathname === "/admin/dashboard" ? activeClass : baseClass} to="/admin/dashboard">
                        Dashboard
                      </NavLink>
                    </li>
                  </>
                ) : (
                  <>
                    {/* <li>
                      <NavLink className={`${HOME_PATHS.includes(pathname) ? activeClass : baseClass}`} to="/">
                        Home
                      </NavLink>
                    </li> */}

                    <li>
                      <NavLink
                        className={`${BUY_SELL_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                        to={getAuthTokenCookie() ? "/buy-sell" : handleNavigateSignup()}
                      >
                        Buy/Sell
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`${PROJECTS_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeClass : baseClass}`}
                        to={getAuthTokenCookie() ? "/projects" : handleNavigateSignup()}
                      >
                        Projects
                      </NavLink>
                    </li>
                  </>
                )}
              </>
            )}
          </ul>

          {!userData.userData ? (
            <div className="hidden lg:flex">
              <span
                className="cursor-pointer hidden lg:inline-block lg:ml-auto lg:mr-3 py-2 px-6 text-sm 3xl:text-lg text-white border border-transparent hover:border hover:border-white font-medium  rounded-full transition duration-200 group-hover:text-primary"
                onClick={handleNavigateLogin}
              >
                Login
              </span>
              <span
                className="cursor-pointer hidden lg:inline-block py-2 px-6 text-sm 3xl:text-lg text-white border border-white font-medium rounded-full transition duration-200 group-hover:text-primary group-hover:border-primary"
                onClick={handleNavigateSignup}
              >
                Sign Up
              </span>
            </div>
          ) : (
            <div className="items-center hidden lg:flex">
              <div>
                <Button
                  className="flex items-center space-x-1"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div className="border border-white rounded-full">
                    <ProfileImageUpload
                      size={32}
                      isEditable={false}
                      image={profile ? storeUserData?.profilePhoto : storeUserData?.vendorProfilePhoto}
                    />
                  </div>
                  {!(storeUserData?.loggedIn === "Admin") && (
                    <div>
                      <div className="text-xs font-semibold text-white capitalize !ml-3 text-left">{storeUserData?.name}</div>
                      <div className="text-white capitalize !ml-3 text-left" style={{ fontSize: "10px" }}>
                        {profile ? "Consumer" : "Vendor"}
                      </div>
                    </div>
                  )}
                  <FiChevronDown className="w-5 h-5 text-white group-hover:text-primary" />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {storeUserData?.consumerKycStatusId === 2 && storeUserData?.loggedIn === "Customer" && (
                    <MenuItem onClick={onClickProfile} className="!text-sm !font-normal !text-black-100">
                      {profile ? "View consumer profile" : "View vendor profile"}
                    </MenuItem>
                  )}
                  {storeUserData?.loggedIn === "Customer" && storeUserData?.vendorKycStatusId === 2 && (
                    <MenuItem onClick={onClickSwitch} className="!text-sm !font-normal !text-black-100">
                      {profile ? "Switch to Vendor" : "Switch to consumer"}
                    </MenuItem>
                  )}
                  {storeUserData?.consumerKycStatusId === 2 &&
                    storeUserData?.loggedIn === "Customer" &&
                    (!storeUserData?.vendorKycStatus || storeUserData?.vendorKycStatusId === 1 || storeUserData?.vendorKycStatusId === 3) && (
                      <MenuItem
                        onClick={() => {
                          if (!storeUserData?.vendorKycStatus) {
                            onClickVendorKyc();
                          } else if (storeUserData?.vendorKycStatusId === 1 || storeUserData?.vendorKycStatusId === 3) {
                            navigate("/vendor-kyc-status");
                          }
                        }}
                        className="!text-sm !font-normal !text-black-100"
                      >
                        Become a vendor
                      </MenuItem>
                    )}
                  <MenuItem onClick={handleLogout} className="!text-sm !font-normal !text-black-100">
                    Logout
                  </MenuItem>
                </Menu>
              </div>
            </div>
          )}
        </nav>
        {/* For mobile */}
        <div className={`${menuVisible ? "" : "navbar-menu relative z-99999 hidden"}`}>
          <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-25" onClick={handleCloseMenu}></div>
          <nav className="fixed top-0 left-0 bottom-0 flex flex-col w-4/6 max-w-xs bg-white border-r overflow-y-auto">
            <div className="flex items-center mb-4 py-4 px-4 bg-primary">
              <span className="text-3xl font-bold leading-none mr-auto">
                <img
                  className={storeUserData?.loggedIn === "Customer" ? "cursor-pointer" : "cursor-default126"}
                  src={require("../../assets/images/gaed-logo.png")}
                  alt="logo"
                  onClick={() => {
                    if (storeUserData?.loggedIn === "Customer") {
                      handleNavigateLanding();
                    }
                  }}
                />
              </span>
              <HiOutlineArrowLeft className="text-white text-2xl" onClick={handleCloseMenu} />
              {/* <button className="navbar-close" >
                <svg
                  className="h-6 w-6 text-white cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button> */}
            </div>
            <div className="p-6 pt-0">
              <div className="mt-auto mb-4">
                {!userData.userData ? (
                  <div className="flex space-x-3">
                    <span
                      className="border w-full cursor-pointer border-primary block px-4 py-2 leading-loose text-xs text-center rounded-full"
                      onClick={handleNavigateLogin}
                    >
                      Login
                    </span>
                    <span
                      className="w-full cursor-pointer block px-4 py-2 leading-loose text-xs text-center text-white font-semibold bg-primary hover:bg-green rounded-full"
                      onClick={handleNavigateSignup}
                    >
                      Sign Up
                    </span>
                  </div>
                ) : (
                  <div className="flex">
                    <Button
                      className="flex !items-center space-x-2 !justify-between !w-full !p-0"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    >
                      <div className="flex items-center">
                        <ProfileImageUpload
                          size={50}
                          isEditable={false}
                          image={profile ? storeUserData?.profilePhoto : storeUserData?.vendorProfilePhoto}
                        />
                        <span className="text-sm font-semibold text-black-900 capitalize !ml-4 text-left">{storeUserData?.name}</span>
                      </div>
                      <FiChevronDown className="w-5 h-5 text-black-900 group-hover:text-primary" />
                    </Button>

                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {storeUserData?.consumerKycStatusId === 2 && storeUserData?.loggedIn === "Customer" && (
                        <MenuItem onClick={onClickProfile} className="!text-sm !font-normal !text-black-100">
                          {profile ? "View consumer profile" : "View vendor profile"}
                        </MenuItem>
                      )}
                      {storeUserData?.loggedIn === "Customer" && storeUserData?.vendorKycStatusId === 2 && (
                        <MenuItem onClick={onClickSwitch} className="!text-sm !font-normal !text-black-100">
                          {profile ? "Switch to Vendor" : "Switch to consumer"}
                        </MenuItem>
                      )}
                      {storeUserData?.consumerKycStatusId === 2 &&
                        storeUserData?.loggedIn === "Customer" &&
                        (!storeUserData?.vendorKycStatus || storeUserData?.vendorKycStatusId === 1 || storeUserData?.vendorKycStatusId === 3) && (
                          <MenuItem
                            onClick={() => {
                              if (!storeUserData?.vendorKycStatus) {
                                onClickVendorKyc();
                              } else if (storeUserData?.vendorKycStatusId === 1 || storeUserData?.vendorKycStatusId === 3) {
                                navigate("/vendor-kyc-status");
                              }
                            }}
                            className="!text-sm !font-normal !text-black-100"
                          >
                            Become a vendor
                          </MenuItem>
                        )}
                      <MenuItem onClick={handleLogout} className="!text-sm !font-normal !text-black-100">
                        Logout
                      </MenuItem>
                    </Menu>
                  </div>
                )}
              </div>
              <Divider />
              <ul className="space-y-8 mt-5">
                {storeUserData?.loggedIn === "Customer" ? (
                  <>
                    {/* <li>
                      <NavLink className={`${HOME_PATHS.includes(pathname) ? activeMobileClass : baseMobileClass}`} to="/">
                        Home
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        className={`${
                          DIRECTORY_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                        }`}
                        onClick={() => {
                          getAuthTokenCookie() ? handleNavigatePlatforms() : handleNavigateSignup();
                        }}
                      >
                        Platforms
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`${
                          BUY_SELL_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                        }`}
                        to={getAuthTokenCookie() ? "/buy-sell" : handleNavigateSignup()}
                      >
                        Buy/Sell
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`${
                          PROJECTS_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                        }`}
                        to={getAuthTokenCookie() ? "/projects" : handleNavigateSignup()}
                      >
                        Projects
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={`${
                          FAQ_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                        }`}
                        to={"/faq"}
                      >
                        FAQ
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        className={`${
                          DIRECTORY_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                        }`}
                        to={getAuthTokenCookie() ? "/directory" : handleNavigateSignup()}
                      >
                        Directory
                      </NavLink>
                    </li> */}
                    {/* {profile && (
                      <li>
                        <NavLink
                          className={`${
                            MY_BIDS_PATH.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                          }`}
                          to={getAuthTokenCookie() ? "/project-list" : handleNavigateSignup()}
                        >
                          Projects
                        </NavLink>
                      </li>
                    )} */}
                    {!profile && (
                      <li>
                        <NavLink
                          className={`${
                            MY_BIDS_PATH.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ? activeMobileClass : baseMobileClass
                          }`}
                          to={getAuthTokenCookie() ? "/my-bids" : handleNavigateSignup()}
                        >
                          My Bids
                        </NavLink>
                      </li>
                    )}
                  </>
                ) : (
                  <>
                    {storeUserData ? (
                      <>
                        <li>
                          <NavLink className={pathname === "/admin/dashboard" ? activeClassAdmin1 : baseClassAdmin1} to="/admin/dashboard">
                            <LuLayoutDashboard className="w-6 h-6 mr-3 transition-colors duration-300 ease-in-out" />
                            Dashboard
                          </NavLink>
                        </li>
                        <li className="!mt-0">
                          <ul className="mt-0 space-y-5">
                            <li
                              className={dashboardTab === 0 ? activeClassAdmin : baseClassAdmin}
                              onClick={() => {
                                dispatch(setAdminDashboardTab(0));
                                handleToggleMenu();
                              }}
                            >
                              <svg
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-6 h-6 mr-3 transition-colors duration-300 ease-in-out"
                              >
                                <path d="M18.3145 8.24395L17.0251 7.99925C16.833 7.1753 16.5226 6.40135 16.1004 5.69325L16.8473 4.57419C17.0863 4.21648 17.0444 3.73276 16.7479 3.42383L15.7241 2.36006C15.4278 2.05235 14.9631 2.00804 14.618 2.25641L13.545 3.02792C12.8488 2.58891 12.1027 2.26819 11.3221 2.07227L11.0914 0.741025C11.0171 0.311775 10.6584 0 10.2385 0H8.78693C8.36723 0 8.00854 0.311369 7.93384 0.741025L7.70345 2.07105C6.92194 2.2621 6.17543 2.58322 5.47939 3.0271L4.40745 2.256C4.06304 2.00926 3.59797 2.05235 3.30128 2.36006L2.27726 3.42383C1.98097 3.73276 1.93911 4.21648 2.1781 4.57419L2.925 5.69325C2.50276 6.40135 2.19238 7.1753 2.00033 7.99925L0.710715 8.24436C0.298836 8.32281 0 8.69556 0 9.1305V10.6333C0 11.0698 0.30001 11.4426 0.713648 11.5198L1.99896 11.7597C2.18417 12.5763 2.49493 13.3519 2.925 14.0717L2.1781 15.1908C1.93911 15.5485 1.98097 16.0322 2.27746 16.3412L3.30128 17.4049C3.59797 17.7135 4.06304 17.757 4.40745 17.5086L5.47939 16.7379C6.17543 17.1818 6.92194 17.5029 7.70345 17.6939L7.93384 19.0244C8.00854 19.4536 8.36723 19.765 8.78693 19.765H10.2385C10.6584 19.765 11.0171 19.4532 11.0914 19.024L11.3221 17.6927C12.1027 17.4968 12.8488 17.1761 13.545 16.7371L14.618 17.509C14.9631 17.7565 15.4278 17.7135 15.7241 17.4049L16.7481 16.3412C17.0444 16.0322 17.0863 15.5485 16.8473 15.1908L16.1004 14.0717C16.5305 13.3519 16.8412 12.5763 17.0264 11.7597L18.312 11.5198C18.7254 11.4426 19.0254 11.0698 19.0254 10.6333V9.1305C19.0254 8.69556 18.7266 8.32281 18.3145 8.24395ZM9.5127 16.1517C6.18815 16.1517 3.48336 13.3409 3.48336 9.88575C3.48336 6.42736 6.18815 3.61366 9.5127 3.61366C12.8373 3.61366 15.542 6.42736 15.542 9.88575C15.542 13.3409 12.8373 16.1517 9.5127 16.1517Z" />
                                <path d="M9.51096 10.6312C10.673 10.6312 11.6183 9.64873 11.6183 8.44118C11.6183 7.23519 10.673 6.25391 9.51096 6.25391C8.35048 6.25391 7.40625 7.23519 7.40625 8.44118C7.40625 9.64873 8.35048 10.6312 9.51096 10.6312Z" />
                                <path d="M11.213 10.6318C10.7484 11.0189 10.1556 11.2562 9.51075 11.2562C8.86589 11.2562 8.27308 11.0189 7.80847 10.6318C6.89524 10.9315 6.23438 11.8181 6.23438 12.8671C6.23438 13.0377 6.36656 13.1792 6.53478 13.1792H12.4867C12.6549 13.1792 12.7871 13.0377 12.7871 12.8671C12.7871 11.8181 12.1263 10.9315 11.213 10.6318Z" />
                              </svg>
                              User Management
                            </li>
                            <li
                              className={dashboardTab === 1 ? activeClassAdmin : baseClassAdmin}
                              onClick={() => {
                                dispatch(setAdminDashboardTab(1));
                                handleToggleMenu();
                              }}
                            >
                              <svg
                                width="16"
                                height="21"
                                viewBox="0 0 16 21"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-6 h-6 mr-3 transition-colors duration-300 ease-in-out"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.7773 13.9424C12.682 13.9442 11.1368 13.9442 11.1418 13.9422V6.43749H15.7773C15.9001 6.43749 16 6.53403 16 6.65263V13.7273C16 13.8459 15.9001 13.9424 15.7773 13.9424ZM0.96137 5.14278H3.89663V5.74911H0.96137V5.14278ZM4.85824 13.9424C2.31219 13.944 0.766765 13.9442 0.222202 13.9435C0.0996818 13.9433 0 13.8468 0 13.7284V6.65263C0 6.53403 0.0999197 6.43749 0.222678 6.43749H4.85824V13.9424ZM1.93916 11.3578H1.09507C1.02156 11.3578 0.96137 11.4157 0.96137 11.487V12.1877C0.96137 12.2588 1.02132 12.3169 1.09507 12.3169H1.93916C2.01267 12.3169 2.07286 12.259 2.07286 12.1877V11.487C2.07286 11.4157 2.01267 11.3578 1.93916 11.3578ZM1.09507 9.02187H1.93916C2.01267 9.02187 2.07286 8.96395 2.07286 8.8927V8.1919C2.07286 8.12088 2.01291 8.06273 1.93916 8.06273H1.09507C1.02156 8.06273 0.96137 8.12065 0.96137 8.1919V8.8927C0.96137 8.96395 1.02156 9.02187 1.09507 9.02187ZM2.91908 9.02187H3.76317C3.83668 9.02187 3.89687 8.96395 3.89687 8.8927V8.1919C3.89687 8.12088 3.83692 8.06273 3.76317 8.06273H2.91908C2.84557 8.06273 2.78538 8.12065 2.78538 8.1919V8.8927C2.78538 8.96395 2.84557 9.02187 2.91908 9.02187ZM3.76317 9.71048H2.91908C2.84557 9.71048 2.78538 9.7684 2.78538 9.83966V10.5402C2.78538 10.6112 2.84533 10.6694 2.91908 10.6694H3.76317C3.83668 10.6694 3.89687 10.6115 3.89687 10.5402V9.83966C3.89687 9.7684 3.83668 9.71048 3.76317 9.71048ZM1.93916 9.71048H1.09507C1.02156 9.71048 0.96137 9.7684 0.96137 9.83966V10.5402C0.96137 10.6112 1.02132 10.6694 1.09507 10.6694H1.93916C2.01267 10.6694 2.07286 10.6115 2.07286 10.5402V9.83966C2.07286 9.7684 2.01267 9.71048 1.93916 9.71048ZM3.76317 11.3578H2.91908C2.84557 11.3578 2.78538 11.4157 2.78538 11.487V12.1877C2.78538 12.2588 2.84533 12.3169 2.91908 12.3169H3.76317C3.83668 12.3169 3.89687 12.259 3.89687 12.1877V11.487C3.89687 11.4157 3.83668 11.3578 3.76317 11.3578ZM7.37812 10.1644H8.62164C8.96613 10.1644 9.24709 10.4092 9.24709 10.7092V13.9424H10.429V2.61357C10.429 2.49497 10.3291 2.39843 10.2063 2.39843C8.73536 2.39843 7.2644 2.39843 5.79344 2.39843C5.67068 2.39843 5.57076 2.49497 5.57076 2.61357V13.9422H6.75267V10.7089C6.75267 10.409 7.03363 10.1644 7.37812 10.1644ZM6.53237 1.1837H7.64362V0.344308C7.64362 0.154226 7.80325 0 8 0C8.19675 0 8.35638 0.154226 8.35638 0.344308V1.1837H9.46763V1.71005C8.48866 1.71005 7.51135 1.71005 6.53237 1.71005V1.1837ZM7.51016 8.17029H6.66607C6.59256 8.17029 6.53237 8.11237 6.53237 8.04112V7.34032C6.53237 7.2693 6.59232 7.21115 6.66607 7.21115H7.51016C7.58367 7.21115 7.64386 7.26907 7.64386 7.34032V8.04112C7.64362 8.11237 7.58367 8.17029 7.51016 8.17029ZM7.51016 6.52277H6.66607C6.59256 6.52277 6.53237 6.46485 6.53237 6.39359V5.69303C6.53237 5.622 6.59232 5.56385 6.66607 5.56385H7.51016C7.58367 5.56385 7.64386 5.62177 7.64386 5.69303V6.39359C7.64362 6.46485 7.58367 6.52277 7.51016 6.52277ZM7.51016 4.87547H6.66607C6.59256 4.87547 6.53237 4.81755 6.53237 4.74629V4.0455C6.53237 3.97448 6.59232 3.91633 6.66607 3.91633H7.51016C7.58367 3.91633 7.64386 3.97425 7.64386 4.0455V4.74629C7.64362 4.81755 7.58367 4.87547 7.51016 4.87547ZM8.35638 6.39382V5.69326C8.35638 5.62223 8.41633 5.56408 8.49008 5.56408H9.33417C9.40768 5.56408 9.46787 5.622 9.46787 5.69326V6.39382C9.46787 6.46485 9.40792 6.523 9.33417 6.523H8.49008C8.41633 6.52277 8.35638 6.46485 8.35638 6.39382ZM9.33393 4.87547H8.48984C8.41633 4.87547 8.35614 4.81755 8.35614 4.74629V4.0455C8.35614 3.97448 8.41609 3.91633 8.48984 3.91633H9.33393C9.40744 3.91633 9.46763 3.97425 9.46763 4.0455V4.74629C9.46763 4.81755 9.40768 4.87547 9.33393 4.87547ZM8.35638 8.04135V7.34055C8.35638 7.26953 8.41633 7.21138 8.49008 7.21138H9.33417C9.40768 7.21138 9.46787 7.2693 9.46787 7.34055V8.04135C9.46787 8.11237 9.40792 8.17052 9.33417 8.17052H8.49008C8.41633 8.17029 8.35638 8.11237 8.35638 8.04135ZM6.07369 14.9059C6.07369 15.9342 6.93562 16.7669 8 16.7669C9.06438 16.7669 9.92631 15.9342 9.92631 14.9059H6.07369ZM14.3078 14.9059V15.7306L13.2624 16.1192C13.1299 16.6573 12.9092 17.1712 12.6089 17.6422L13.0638 18.6319L11.8564 19.7984L10.8325 19.3589C10.345 19.649 9.81283 19.8623 9.25566 19.9903L8.85336 21H7.14592L6.74363 19.9901C6.1867 19.862 5.65474 19.6487 5.16728 19.3587L4.14286 19.7981L2.9355 18.6317L3.39037 17.6424C3.09014 17.1715 2.86936 16.6573 2.73685 16.119L1.69174 15.7303V14.9057H5.02216C5.02216 16.4946 6.35513 17.7824 7.99976 17.7824C9.64439 17.7824 10.9774 16.4946 10.9774 14.9057L14.3078 14.9059ZM12.1031 5.14278H15.0384V5.74911H12.1031V5.14278ZM13.0809 11.3578H12.2368C12.1633 11.3578 12.1031 11.4157 12.1031 11.487V12.1877C12.1031 12.2588 12.1631 12.3169 12.2368 12.3169H13.0809C13.1544 12.3169 13.2146 12.259 13.2146 12.1877V11.487C13.2146 11.4157 13.1544 11.3578 13.0809 11.3578ZM12.2368 9.02187H13.0809C13.1544 9.02187 13.2146 8.96395 13.2146 8.8927V8.1919C13.2146 8.12088 13.1547 8.06273 13.0809 8.06273H12.2368C12.1633 8.06273 12.1031 8.12065 12.1031 8.1919V8.8927C12.1031 8.96395 12.1633 9.02187 12.2368 9.02187ZM14.0608 9.02187H14.9049C14.9784 9.02187 15.0386 8.96395 15.0386 8.8927V8.1919C15.0386 8.12088 14.9787 8.06273 14.9049 8.06273H14.0608C13.9873 8.06273 13.9271 8.12065 13.9271 8.1919V8.8927C13.9271 8.96395 13.9873 9.02187 14.0608 9.02187ZM14.9049 9.71048H14.0608C13.9873 9.71048 13.9271 9.7684 13.9271 9.83966V10.5402C13.9271 10.6112 13.9871 10.6694 14.0608 10.6694H14.9049C14.9784 10.6694 15.0386 10.6115 15.0386 10.5402V9.83966C15.0386 9.7684 14.9784 9.71048 14.9049 9.71048ZM13.0809 9.71048H12.2368C12.1633 9.71048 12.1031 9.7684 12.1031 9.83966V10.5402C12.1031 10.6112 12.1631 10.6694 12.2368 10.6694H13.0809C13.1544 10.6694 13.2146 10.6115 13.2146 10.5402V9.83966C13.2146 9.7684 13.1544 9.71048 13.0809 9.71048ZM14.9049 11.3578H14.0608C13.9873 11.3578 13.9271 11.4157 13.9271 11.487V12.1877C13.9271 12.2588 13.9871 12.3169 14.0608 12.3169H14.9049C14.9784 12.3169 15.0386 12.259 15.0386 12.1877V11.487C15.0386 11.4157 14.9784 11.3578 14.9049 11.3578Z"
                                />
                              </svg>
                              Projects
                            </li>

                            <li
                              className={dashboardTab === 2 ? activeClassAdmin : baseClassAdmin}
                              onClick={() => {
                                dispatch(setAdminDashboardTab(2));
                                handleToggleMenu();
                              }}
                            >
                              <svg
                                width="20"
                                height="18"
                                viewBox="0 0 20 18"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-6 h-6 mr-3 transition-colors duration-300 ease-in-out"
                              >
                                <path d="M12.9929 14.1123H6.99293C6.96703 14.1129 6.94235 14.1235 6.92403 14.1418C6.9057 14.1601 6.89514 14.1848 6.89453 14.2107V17.7747H13.0913V14.2107C13.0907 14.1848 13.0802 14.1601 13.0618 14.1418C13.0435 14.1235 13.0188 14.1129 12.9929 14.1123Z" />
                                <path d="M1.47111 0.635986L0.434306 6.10079C0.378513 6.39009 0.387907 6.68819 0.461805 6.9734C0.535704 7.25862 0.672248 7.52378 0.861507 7.74959C0.996802 7.91686 1.15902 8.06043 1.34151 8.17439C1.63127 8.35447 1.9622 8.4576 2.30297 8.47401C2.64374 8.49041 2.98305 8.41955 3.28877 8.26814C3.59449 8.11672 3.85649 7.88976 4.04996 7.60875C4.24343 7.32775 4.36195 7.00201 4.39431 6.66239L5.00391 0.225586H1.96551C1.84822 0.22578 1.73467 0.266873 1.64443 0.341785C1.55418 0.416698 1.49289 0.520739 1.47111 0.635986Z" />
                                <path d="M13.9767 0.225586H10.5039V6.46559C10.5045 6.9973 10.7162 7.50702 11.0924 7.88277C11.4686 8.25853 11.9786 8.46959 12.5103 8.46959H12.5535C12.8331 8.47145 13.1099 8.41473 13.3662 8.30309C13.6225 8.19144 13.8526 8.02735 14.0416 7.82137C14.2306 7.61539 14.3744 7.3721 14.4637 7.10717C14.5529 6.84224 14.5857 6.56155 14.5599 6.28319L14.3919 4.48319L13.9767 0.225586Z" />
                                <path d="M5.96286 7.82122C6.14994 8.0288 6.37879 8.19448 6.6344 8.3074C6.89002 8.42032 7.16662 8.47792 7.44606 8.47642H7.48926C8.02075 8.47642 8.53047 8.26529 8.9063 7.88946C9.28212 7.51364 9.49326 7.00392 9.49326 6.47242V0.232422H6.02286L5.45165 6.28522C5.42323 6.56285 5.4541 6.84335 5.54223 7.10814C5.63036 7.37294 5.77373 7.616 5.96286 7.82122Z" />
                                <path d="M19.1355 7.74959C19.3247 7.52378 19.4613 7.25862 19.5352 6.9734C19.6091 6.68819 19.6185 6.39009 19.5627 6.10079L18.5259 0.635986C18.5041 0.520739 18.4428 0.416698 18.3526 0.341785C18.2623 0.266873 18.1488 0.22578 18.0315 0.225586H14.9883L15.5979 6.66239C15.6347 7.05709 15.7878 7.43199 16.038 7.73953C16.2881 8.04708 16.6239 8.27343 17.0028 8.38989C17.3818 8.50634 17.7867 8.50766 18.1664 8.39366C18.5461 8.27967 18.8834 8.0555 19.1355 7.74959Z" />
                                <path d="M18.424 17.2708V9.36759C17.8047 9.54896 17.1435 9.52599 16.5383 9.30206C15.9331 9.07813 15.4161 8.66517 15.064 8.12439C14.9797 8.25789 14.8842 8.38394 14.7784 8.50119C14.495 8.8095 14.1508 9.05571 13.7674 9.22425C13.3841 9.39279 12.97 9.48 12.5512 9.48039H12.508C12.0116 9.48131 11.5227 9.35954 11.0847 9.1259C10.6467 8.89226 10.2733 8.55399 9.99761 8.14119C9.72192 8.55399 9.34848 8.89226 8.91051 9.1259C8.47253 9.35954 7.9836 9.48131 7.48721 9.48039H7.44401C7.0239 9.47975 6.60852 9.39173 6.22427 9.22192C5.84002 9.0521 5.49529 8.80421 5.21201 8.49399C5.10626 8.37674 5.01071 8.25069 4.92641 8.11719C4.57405 8.65769 4.05707 9.07041 3.45195 9.29431C2.84683 9.5182 2.18571 9.54137 1.56641 9.36039V17.2708C1.56672 17.3375 1.58021 17.4035 1.6061 17.465C1.63199 17.5264 1.66977 17.5822 1.71727 17.629C1.76477 17.6759 1.82106 17.7128 1.8829 17.7379C1.94473 17.7629 2.0109 17.7754 2.07761 17.7748H5.89361V14.2108C5.89361 13.9167 6.01043 13.6347 6.21837 13.4267C6.42631 13.2188 6.70833 13.102 7.00241 13.102H13.0024C13.2965 13.102 13.5785 13.2188 13.7864 13.4267C13.9944 13.6347 14.1112 13.9167 14.1112 14.2108V17.7748H17.9176C17.984 17.7751 18.0498 17.7623 18.1112 17.7371C18.1726 17.7119 18.2285 17.6749 18.2755 17.628C18.3226 17.5812 18.3599 17.5255 18.3854 17.4642C18.4109 17.4029 18.424 17.3372 18.424 17.2708ZM13.5976 12.1612H6.39761C6.2782 12.1426 6.16937 12.082 6.09075 11.9902C6.01214 11.8985 5.96893 11.7816 5.96893 11.6608C5.96893 11.54 6.01214 11.4231 6.09075 11.3313C6.16937 11.2396 6.2782 11.1789 6.39761 11.1604H13.5976C13.7256 11.1692 13.8454 11.2263 13.933 11.32C14.0205 11.4138 14.0692 11.5373 14.0692 11.6656C14.0692 11.7939 14.0205 11.9174 13.933 12.0111C13.8454 12.1049 13.7256 12.162 13.5976 12.1708V12.1612Z" />
                              </svg>
                              Buy/Sell
                            </li>
                            {/* <li
                              className={dashboardTab === 3 ? activeClassAdmin : baseClassAdmin}
                              onClick={() => {
                                dispatch(setAdminDashboardTab(3));
                                handleToggleMenu();
                              }}
                            >

                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-7 h-7 mr-3 transition-colors duration-300 ease-in-out"
                              >
                                <path d="M12 22.5C10.8 21.3667 9.425 20.5 7.875 19.9C6.325 19.3 4.7 19 3 19V8C4.68333 8 6.3 8.30417 7.85 8.9125C9.4 9.52083 10.7833 10.4 12 11.55C13.2167 10.4 14.6 9.52083 16.15 8.9125C17.7 8.30417 19.3167 8 21 8V19C19.2833 19 17.6542 19.3 16.1125 19.9C14.5708 20.5 13.2 21.3667 12 22.5ZM12 9C10.9 9 9.95833 8.60833 9.175 7.825C8.39167 7.04167 8 6.1 8 5C8 3.9 8.39167 2.95833 9.175 2.175C9.95833 1.39167 10.9 1 12 1C13.1 1 14.0417 1.39167 14.825 2.175C15.6083 2.95833 16 3.9 16 5C16 6.1 15.6083 7.04167 14.825 7.825C14.0417 8.60833 13.1 9 12 9Z" />
                              </svg>
                              Directory
                            </li> */}
                          </ul>
                        </li>
                      </>
                    ) : (
                      <>
                        {/* <li>
                          <NavLink className={`${HOME_PATHS.includes(pathname) ? activeMobileClass : baseMobileClass}`} to="/">
                            Home
                          </NavLink>
                        </li> */}

                        <li>
                          <NavLink
                            className={`${
                              BUY_SELL_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))
                                ? activeMobileClass
                                : baseMobileClass
                            }`}
                            to={getAuthTokenCookie() ? "/buy-sell" : handleNavigateSignup()}
                          >
                            Buy/Sell
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={`${
                              PROJECTS_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))
                                ? activeMobileClass
                                : baseMobileClass
                            }`}
                            to={getAuthTokenCookie() ? "/projects" : handleNavigateSignup()}
                          >
                            Projects
                          </NavLink>
                        </li>
                      </>
                    )}
                  </>
                )}
                {/* <li className="mb-1">
                  <span
                    onClick={handleNavigateLanding}
                    className="cursor-pointer block p-4 text-sm font-semibold text-gray-400 hover:bg-blue-50 hover:text-blue-600 rounded"
                  >
                    Home
                  </span>
                </li>
                <li className="mb-1">
                  <span className="block p-4 text-sm font-semibold text-gray-400 hover:bg-blue-50 hover:text-blue-600 rounded">Marketplace</span>
                </li>
                <li className="mb-1">
                  <span className="block p-4 text-sm font-semibold text-gray-400 hover:bg-blue-50 hover:text-blue-600 rounded">
                    Property Management
                  </span>
                </li>
                <li className="mb-1">
                  <span className="block p-4 text-sm font-semibold text-gray-400 hover:bg-blue-50 hover:text-blue-600 rounded">
                    Project Management
                  </span>
                </li>
                <li className="mb-1">
                  <span className="block p-4 text-sm font-semibold text-gray-400 hover:bg-blue-50 hover:text-blue-600 rounded">Buy/Sell</span>
                </li> */}
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
